import { Stack, Typography, Card, Divider, useTheme } from "@mui/material";
import { Icon } from "@iconify/react";

import { Strings } from "@app/constants";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";

interface Props {
  productData: any;
  onSubmit: () => void;
  loading: boolean;
}

const ProductSummary = ({ productData, onSubmit, loading }: Props) => {
  const theme = useTheme();
  const [rating, setRating] = useState<number>(0);

  return (
    <Card
      variant="outlined"
      sx={{
        p: 3,
      }}
    >
      <Typography fontWeight={700} gutterBottom color={theme.palette.grey[900]}>
        {Strings.buy.productSummary}
      </Typography>

      <Stack direction="row" spacing={2} mb={2} alignItems="flex-start">
        <Stack
          sx={{
            width: 310,
            height: 150,
            objectFit: "contain",
            borderRadius: "4px",
          }}
        >
          <img
            src={productData?.images?.[0]?.url}
            alt={productData?.name}
            loading="lazy"
            style={{
              width: 310,
              height: 150,
              objectFit: "fill",
              borderRadius: "4px",
            }}
          />
        </Stack>
        {/* <Stack> */}
        {/* <Typography fontWeight={700} fontSize={25} fontFamily={"Work Sans"}>
            {`${productData?.brand?.name} ${productData?.model?.name}`}
          </Typography> */}

        {/* <Stack direction="row" alignItems="center">
            <Stack direction="row" alignItems="center">
              {Array?.from({ length: 5 })?.map((_, index) => {
                const starIndex = index + 1;
                return (
                  <Icon
                    key={starIndex}
                    icon={
                      starIndex <= rating
                        ? "ic:round-star"
                        : "ic:round-star-border"
                    }
                    style={{ width: 15, height: 15, cursor: "pointer" }}
                    color={
                      starIndex <= rating
                        ? theme.palette.warning.main
                        : theme.palette.grey[400]
                    }
                    onClick={() => setRating(starIndex)}
                  />
                );
              })}
            </Stack>
            <Typography sx={{ color: theme.palette.grey[500], fontSize: 10 }}>
              {Strings.buy.reviewer(440)}
            </Typography>
          </Stack> */}
        {/* </Stack> */}
      </Stack>

      {/* <Divider sx={{ my: 2 }} /> */}

      {/* <Stack spacing={1}>
        <Stack direction="row" justifyContent="space-between">
          <Typography>{Strings.buy.subTotal}</Typography>
          <Typography>
            ${productData?.price?.toLocaleString() || "0"}
          </Typography>
        </Stack>

        <Stack direction="row" justifyContent="space-between">
          <Typography>{Strings.buy.tax}</Typography>
          <Typography>{"$0"}</Typography>
        </Stack>

        <Stack direction="row" justifyContent="space-between">
          <Typography>{Strings.buy.discount}</Typography>
          <Typography>
            ${productData?.discount?.toLocaleString() || "0"}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          mt={1}
        >
          <Stack>
            <Typography fontWeight={700}>{Strings.buy.totalPrice}</Typography>
            <Typography variant="caption">
              {Strings.buy.overallPriceAnd}
            </Typography>
          </Stack>
          <Typography fontWeight={700} color="primary">
            ${(productData?.price || 0) - (productData?.discount || 0)}
          </Typography>
        </Stack>
      </Stack> */}
      <Stack>
        <Typography sx={{ fontWeight: "700", fontSize: 26 }}>
          {`${productData?.brand?.name} ${productData?.model?.name}`}
        </Typography>
      </Stack>
      <LoadingButton
        variant="contained"
        fullWidth
        sx={{ mt: 3 }}
        onClick={onSubmit}
        loading={loading}
      >
        {Strings.button.bookNow}
      </LoadingButton>
    </Card>
  );
};

export { ProductSummary };
